import { createRouter, createWebHashHistory } from 'vue-router';
import Lists from '../views/Lists.vue';
import List from '../views/List.vue';
import Overview from '../views/Overview.vue';

import store from '../store'

const routes = [
	{
		path: '/',
		component: Lists
	},
	{
		path: '/:listId(\\d+)',
		component: List,
		beforeEnter(route) {
			
			if (!store.state.kitId) {
                store.commit('setKitId', parseInt(route.params.listId));
                store.commit('nextStep');
            }
		}
	},
	{
		path: '/:listId(\\d+)/overview/',
		component: Overview,
		beforeEnter(route) {
			if (store.getters.isCartEmpty) {
				return `/${route.params.listId}`;
			}
		}
	}
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

export default router;
